import React from 'react';

export const AppFooter: React.FC = () => {
  return (
    <footer className="mt-12 text-center py-6 border-t border-gray-200 dark:border-gray-600 bg-white/50 dark:bg-gray-800/50 transition-colors duration-300">
      {/* Footer content cleared - reserved for future use */}
    </footer>
  );
};